import { format, utcToZonedTime } from "date-fns-tz";

export const isValidCPF = (cpf) => {
    if (typeof cpf !== "string") return false;
    cpf = cpf.replace(/[\s.-]*/gim, "");
    if (
        !cpf ||
        cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999"
    ) {
        return false;
    }
    var soma = 0;
    var resto;
    for (var i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;
    soma = 0;
    for (var i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;
    return true;
};

export const isValidPassport = (passport) => {
    // Verifica se o passaporte é uma string
    if (typeof passport !== "string") {
        return false;
    }

    // Remove espaços em branco do início e do final da string
    passport = passport.trim();

    // Verifica o comprimento do passaporte
    if (passport.length < 6 || passport.length > 20) {
        return false;
    }

    // Verifica se o passaporte contém apenas letras e números
    if (!/^[a-zA-Z0-9]+$/.test(passport)) {
        return false;
    }
    return true;
};

export const base64ToFile = (base64, fileName) => {
    const [header, data] = base64.split(",");
    const mime = header.match(/:(.*?);/)[1];
    const binary = atob(data);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }

    return new File([new Uint8Array(array)], fileName, { type: mime });
};

export const formatPhoneNumber = (phone) => {
    if (!phone) return "";

    const cleanPhone = phone.replace(/\D/g, "");

    if (cleanPhone.startsWith("55") && cleanPhone.length === 13) {
        // Formato internacional: 55 98 98256-5996 (sem o "+")
        return cleanPhone.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4");
    } else if (cleanPhone.length === 11) {
        // Formato nacional: (98) 98256-5996
        return cleanPhone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    } else if (cleanPhone.length === 10) {
        // Caso de número com 10 dígitos (sem o nono dígito): (98) 8256-5996
        return cleanPhone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    } else {
        // Retorna o número sem formatação caso não caia em nenhum dos casos
        return phone;
    }
};

export const formatDateToTimeZoneUTC = (date) => {
    const timeZone = "America/Sao_Paulo";
    const zonedDate = utcToZonedTime(date, timeZone);
    const formattedDate = format(zonedDate, "yyyy-MM-dd HH:mm:ss.SSS", { timeZone });
    return formattedDate;
};

export const getFirstAndLastNames = (name) => {
    if (!name) return "";
    let nameVector = name.trim().split(" ");
    if (nameVector.length > 2) return `${nameVector[0]} ${nameVector[nameVector.length - 1]}`;
    else if (nameVector.length === 1) return nameVector[0];
    else return name;
};
